import {
  Autocomplete,
  CircularProgress,
  ListItemText,
  MenuItem,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useAlerts } from "../../context/AlertContext";
import BaseProductService from "../../service/BaseProductService";
import { FormTextField } from "./FormTextField";

export default function ProductCategoryAutocomplete({
  field: { name, value, onChange, onBlur },
  form: { touched, errors },
  label,
  ...props
}) {
  const { addErrorAlert } = useAlerts();
  const [loading, setLoading] = useState(false);
  const [displayText, setDisplayText] = useState("");
  const [categories, setCategories] = useState([]);
  const [filteredCategories, setFilteredCategories] = useState([]);

  useEffect(() => {
    setLoading(true);
    BaseProductService.getProductCategories()
      .then((response) => {
        setCategories(response);
        setFilteredCategories(response);
      })
      .catch((error) => {
        addErrorAlert("Error fetching categories", error);
      })
      .finally(() => setLoading(false));
  }, [addErrorAlert]);

  useEffect(() => {
    if (props.value || !displayText) {
      setFilteredCategories(categories);
    } else {
      setFilteredCategories(
        categories.filter((category) =>
          category.displayText.toLowerCase().includes(displayText.toLowerCase())
        )
      );
    }
  }, [displayText, categories, props.value]);

  return (
    <Autocomplete
      label={label}
      size="small"
      fullWidth
      id={name}
      data-testid={name}
      loading={loading}
      inputValue={displayText}
      autoHighlight
      onInputChange={(e, newInputValue) => {
        setDisplayText(newInputValue);
      }}
      noOptionsText={
        displayText ? "No categories found" : "Start typing to search"
      }
      isOptionEqualToValue={(option, value) => option.id === value?.id}
      getOptionLabel={(option) => {
        if (option.id) {
          return `${option.displayText}`;
        } else {
          return option;
        }
      }}
      options={filteredCategories}
      renderOption={(props, categoryOption) => {
        if (categoryOption.id) {
          return (
            <MenuItem {...props} key={categoryOption.id}>
              <ListItemText primary={categoryOption.displayText} />
            </MenuItem>
          );
        }
      }}
      name={name}
      value={value}
      {...props}
      onChange={(e, newValue) => {
        onChange({ target: { name: name, value: newValue } });
      }}
      renderInput={(params) => (
        <FormTextField
          {...params}
          field={{
            name,
            value,
            onChange: (e) => {
              setDisplayText(e.target.value);
            },
            onBlur,
          }}
          form={{ touched, errors }}
          label={label}
          required={props.required}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}
